<template>
  <datepicker
    format="dd/MM/yyyy"
    :typeable="true"
    inputClass="md-input"
    :name="id"
    v-model="data_valor"
    :language="language_date"
    calendar-button-icon-content="event"
    :input="datepicker_inputchanged"
  ></datepicker>
</template>
<script>
import Datepicker from "./vuejs-datepicker/src/components/Datepicker";
import ptBR from "./vuejs-datepicker/src/locale/translations/pt-BR";
import Util from "../../library/Util";

export default {
  components: {
    Datepicker,
  },
  props: {
    id: {
      type: String,
      default: function() {
          return "datepicker";
        },
    },
    value: {
      //Data no formato da api...
      type: String,
      default:  function() {
          return "";
        },
    },
    onChange:{
      type: Function
    }
  },
  model: {
    prop: "value",
    event: "selected",
  },
  watch: {
    data_valor: function (old, novo) {
      if (old != novo && this.mounted) {
        if (this.data_valor) {
          var toapi = Util.dateToBd(this.data_valor);
          this.$emit("selected", toapi);
          //console.log("selected? ", toapi );
          if ( this.onChange ){
              this.onChange(toapi, this.id );
          }
        }else{
          this.$emit("selected", null);
          if ( this.onChange ){
              this.onChange(null, this.id );
          }
        }
      }
    },
  },
  data() {
    return {
      language_date: ptBR,
      data_valor: null,
      mounted: false,
    };
  },
  methods: {
    datepicker_inputchanged() {

      
    },
  },
  mounted() {
    if (this.value && this.value.length >= 8) {
      var intData = Util.getApiDateInt(this.value);
      this.data_valor = new Date(intData);
    }

    this.mounted = true;
  },
};
</script>
